





























import {Component, Vue, Prop} from 'vue-property-decorator'
import {Rate, TimeOverride} from '../lib/kepler/interfaces'
import DataTable from './proxy/DataTable.vue'
import DateHelper from '../lib/DateHelper'
import Divider from '@/components/proxy/Divider.vue'
import Layout from '@/components/proxy/Layout.vue'
import Container from '@/components/proxy/Container.vue'
import moment from 'moment'

@Component({
  name: 'TimeOverrides',
  components: {Container, Layout, Divider, DataTable},
})
export default class TimeOverrides extends Vue {
  @Prop({default: () => []}) public timeOverrides!: TimeOverride[]
  @Prop() public rate!: Rate

  public days: string[] = [
    '', // first row empty
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
  ]

  public get Headers() {
    const arr = []

    function parseEnglishDay(day: string) {
      const locale = moment.locale()
      return moment().locale('en').day(day) // parse in english
        .locale(locale).format('ddd') // outputs in selected locale
        .replace(/^\w/, (c) => c.toUpperCase()) // capitalize
    }

    for (const day of this.days) {
      arr.push({
        text: day ? parseEnglishDay(day) : '',
        align: 'center',
        sortable: false,
        value: 'name',
      })
    }
    return arr
  }

  public parseMinutes(val: number) {
    return DateHelper.parseMinutes(this, val)
  }
}
